import "./Policy.css";

function Policy ({policyId}) {
  return (
<>
<div className="policy-id-area">
          <p className="policy-id-header">Policy ID</p>
          <p className="policy-id-value">{policyId}</p>
        </div>
      </>
  );
}

export default Policy;